class TabsBrands extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('.hdt-tab-link');
    this.tabs = this.querySelectorAll('.hdt-tab-content');
    this.addAllListeners();
  }

  addAllListeners() {
    this.links.forEach(link => {
      link.addEventListener('click', () => {
        const tabName = link.getAttribute('data-filter');
        if (tabName === 'all') {
          this.openAllTabs();
        } else {
          this.openTab(tabName);
        }
        this.links.forEach(item => {
          item.classList.remove('is--active');
        });
        if (!link.classList.contains('is--active')) {
          link.classList.add('is--active');
        }
      });
    });
  }

  openAllTabs() {
    this.tabs.forEach(content => {
      content.style.display = 'block';
      content.style.height = 'auto';
    });
    this.querySelector('[data-filter="all"]').classList.add('is--active');
  }

  openTab(tabName) {
    this.tabs.forEach(content => {
      if (content.id === tabName) {
        content.style.display = 'block';
        content.classList.add('slideInRight');
      } else {
        content.style.display = 'none';
        content.classList.remove('slideInRight');
      }
    });
  }

  connectedCallback() {
    this.addAllListeners();
  }
  disconnectedCallback() {
  }
}

customElements.define('tabs-brands', TabsBrands);

//  //


// JavaScript الخليج او غيرها

document.addEventListener("DOMContentLoaded", function () {
    function checkCurrency() {
        var shippingBar = document.getElementById("shipping-bar-container"),
            shippingBarCoupon = document.getElementById("coupon"),
            currencyText = document.querySelector(".money")?.textContent.trim() || "";

        if (shippingBar) {
            shippingBar.style.display = currencyText.includes("OMR") ? "block" : "none";
            if (shippingBarCoupon) shippingBarCoupon.style.display = currencyText && !currencyText.includes("OMR") ? "block" : "none";
        }
    }

    checkCurrency();
    new MutationObserver(checkCurrency).observe(document.body, { childList: true, subtree: true });

    function syncCartText() {
        let shipText = document.querySelector("[data-cart-ship-text]")?.innerHTML.trim(),
            copTextElement = document.querySelector("[data-cart-cop-text]");

        if (shipText && copTextElement) {
            let updatedText = shipText.replace(/شحن مجاني/g, "كوبون تخفيض").replace(/FREE SHIPPING/g, "DISCOUNT COUPON");

            if (copTextElement.innerHTML.trim() !== updatedText) {
                copTextElement.innerHTML = updatedText;
            }
        }
    }

    syncCartText();
    setInterval(syncCartText, 500);
    new MutationObserver(syncCartText).observe(document.querySelector("[data-cart-ship-text]"), { childList: true, subtree: true, characterData: true });
});

// JavaScript لاخفاء الشريط الاحمر الذي فوق للعملات الاخرى

document.addEventListener("DOMContentLoaded", function() {
  function checkCurrency() {
    var isCart = location.pathname.includes("/cart");
    var isOMR = [...document.querySelectorAll("span.money")].some(el => el.innerText.includes("OMR"));
    var bar = document.querySelector(".t4s-announcement-bar");
    if (bar) bar.style.display = isCart ? "none" : (isOMR ? "block" : "none");
  }
  checkCurrency();
  new MutationObserver(checkCurrency).observe(document.body, { childList: true, subtree: true, characterData: true });
});

/*
// JavaScript المناطق والخريطة
document.addEventListener("DOMContentLoaded", function() {
    function checkCurrencyAndLanguage() {
        // تحقق إذا كانت العملة عمانية
        var isOMR = Array.from(document.querySelectorAll("span.money"))
                         .some(el => el.innerText.includes("OMR"));

        // تحقق إذا كانت اللغة الإنجليزية
        var isEnglish = document.documentElement.lang === "en" || document.documentElement.lang === "en-US";

        // البحث عن الزر
        var openMapBtn = document.getElementById("open-map-modal");

        if (openMapBtn) {
            // إخفاء الزر إذا كانت اللغة إنجليزية أو العملة ليست عمانية
            openMapBtn.style.display = (isOMR && !isEnglish) ? "inline-block" : "none";
        }
    }

    // تحقق أول مرة بعد تحميل الصفحة
    checkCurrencyAndLanguage();

    // مراقبة التغييرات في المستند لتحديث الحالة عند التغيير
    new MutationObserver(checkCurrencyAndLanguage).observe(document.body, { childList: true, subtree: true, characterData: true });
});


//  كود بروماكس
/*
document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("map-modal");
    const openModalBtn = document.getElementById("open-map-modal");
    const closeModalBtn = document.getElementById("close-map-modal");
    const deliveryInfo = document.getElementById("delivery-info");
    const selectedAreaName = document.getElementById("selected-area-name");
    const mapImage = document.getElementById("delivery-map");

    if (!modal || !openModalBtn || !closeModalBtn || !deliveryInfo || !selectedAreaName || !mapImage) {
        console.error("❌ خطأ: لم يتم العثور على أحد العناصر الأساسية للنافذة المنبثقة.");
        return;
    }

    openModalBtn.addEventListener("click", function () {
        document.documentElement.classList.add("t4s-modal-opened");
        modal.classList.add("t4s-modal--is-active");
        modal.style.display = "flex";
        console.log("✅ النافذة المنبثقة تعمل الآن.");
    });

    closeModalBtn.addEventListener("click", function () {
        modal.classList.remove("t4s-modal--is-active");
        modal.style.display = "none";
        document.documentElement.classList.remove("t4s-modal-opened");
        console.log("✅ النافذة تم إغلاقها.");
    });

    modal.addEventListener("click", function (event) {
        if (event.target === modal) {
            modal.classList.remove("t4s-modal--is-active");
            modal.style.display = "none";
            document.documentElement.classList.remove("t4s-modal-opened");
            console.log("✅ النافذة تم إغلاقها بالنقر خارج الصورة.");
        }
    });

    function showInfo(event, area, minDays, maxDays) {
        if (event) {
            event.preventDefault();
        }

        let today = new Date();
        let startDate = new Date(today);
        startDate.setDate(today.getDate() + minDays);

        let endDate = new Date(today);
        endDate.setDate(today.getDate() + maxDays);

        let options = { weekday: 'long', day: 'numeric', month: 'long' };
        let startFormatted = startDate.toLocaleDateString('ar-EG', options);
        let endFormatted = endDate.toLocaleDateString('ar-EG', options);

    // ✅ تعيين النص والتنسيق مباشرة داخل JavaScript
    deliveryInfo.innerHTML = `
        <div id="delivery-box">
<strong id="delivery-title">🚚 اطلب الآن، توصيل لـ ${area} بين:</strong>
<br>           
<span id="delivery-date">${startFormatted} - ${endFormatted}</span>

    `;

    // ✅ تطبيق التنسيق باستخدام JavaScript فقط
    let deliveryBox = document.getElementById("delivery-box");
    let deliveryTitle = document.getElementById("delivery-title");
    let deliveryDate = document.getElementById("delivery-date");

    if (deliveryBox) {
        deliveryBox.style.background = "rgba(0, 0, 0, 0.8)"; // خلفية سوداء شفافة
        deliveryBox.style.color = "white"; // نص أبيض
        deliveryBox.style.padding = "12px 15px";
        deliveryBox.style.borderRadius = "8px";
        deliveryBox.style.boxShadow = "0 4px 10px rgba(0, 0, 0, 0.2)";
        deliveryBox.style.fontSize = "16px";
        deliveryBox.style.fontWeight = "bold";
        deliveryBox.style.position = "absolute";
        deliveryBox.style.textAlign = "center";
        deliveryBox.style.minWidth = "200px";
        deliveryBox.style.display = "block"; // إظهار العنصر
    }

    if (deliveryTitle) {
        deliveryTitle.style.fontSize = "10px";
        deliveryTitle.style.color = "#ffcc00"; // لون ذهبي
    }

    if (deliveryDate) {
        deliveryDate.style.fontSize = "10px";
        deliveryDate.style.color = "#00e676"; // لون أخضر فاتح
    }


        // ✅ تحديد موضع النقر داخل الخريطة
        let rect = mapImage.getBoundingClientRect();
        let x = event.clientX - rect.left;
        let y = event.clientY - rect.top;

        // ✅ تحديد إذا كان النص يخص "التوصيل إلى ظفار" أو لا
        if (area === "ظفار") {
            // تعديل الموضع ليكون النص فوق النقرة وأيضا إلى اليمين
            y -= deliveryBox.offsetHeight; // تعديل الموضع ليكون النص فوق النقرة
            x += 90; // تحريك النص إلى اليمين قليلاً
        }


        deliveryInfo.style.position = "absolute";
        deliveryInfo.style.left = `${x}px`;
        deliveryInfo.style.top = `${y}px`;
        deliveryInfo.style.zIndex = "99999"; // ✅ رفع النص فوق الصورة
        deliveryInfo.classList.add("show");

        console.log(`✅ وقت التوصيل إلى ${area}: ${startFormatted} إلى ${endFormatted} (الموقع داخل الصورة: ${x}px, ${y}px)`);
    }

    window.showInfo = showInfo;
});



    // عيد كود بروماكس  JavaScript
/*
document.addEventListener("DOMContentLoaded", function () {
    // التحقق من أن النافذة لم تظهر من قبل
    if (localStorage.getItem("popupShown") === "true") {
        var lastClosedTime = localStorage.getItem("popupClosedTime");
        var currentTime = new Date().getTime();
        
        // إظهار النافذة فقط إذا مر 30 دقيقة بعد الإغلاق الأخير
if (lastClosedTime && currentTime - lastClosedTime < 60 * 60 * 1000) {
            return; // لا تظهر إذا كانت أقل من 30 دقيقة
        }
    }

    // إنشاء النافذة المنبثقة ديناميكيًا
    var popup = document.createElement("div");
    popup.id = "popup-modal";
    popup.className = "popup-overlay";
    popup.innerHTML = `
        <div class="popup-content">
            <span id="close-popup" class="close-btn">&times;</span>
            <img id="popup-image" src="https://cdn.shopify.com/s/files/1/0619/3915/5027/files/27-3-min.jpg" alt="Popup Image" class="popup-image">
        </div>
    `;
    document.body.appendChild(popup);

    var closeBtn = document.getElementById("close-popup");
    var popupImage = document.getElementById("popup-image");

    function closeModal() {
        popup.style.display = "none";
        localStorage.setItem("popupShown", "true"); // تخزين لمنع الظهور مرة أخرى
        localStorage.setItem("popupClosedTime", new Date().getTime()); // تخزين وقت الإغلاق
    }

    // إغلاق عند الضغط على زر الإغلاق (×)
    if (closeBtn) {
        closeBtn.addEventListener("click", closeModal);
    }

    // إغلاق عند الضغط خارج النافذة
    document.addEventListener("click", function (event) {
        if (event.target === popup) {
            closeModal();
        }
    });

    // إغلاق عند الضغط على الصورة نفسها
    if (popupImage) {
        popupImage.addEventListener("click", closeModal);
    }

    // عرض النافذة بعد ثانية واحدة فقط
    setTimeout(function () {
        popup.style.display = "flex";
    }, 1000);

    // إضافة CSS ديناميكيًا لتنسيق النافذة
    var style = document.createElement("style");
    style.innerHTML = `
        .popup-overlay {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
        }

        .popup-content {
            background: #fff;
            padding: 20px;
            border-radius: 10px;
            text-align: center;
            position: relative;
            max-width: 90%;
            width: 400px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .close-btn {
            position: absolute;
            top: 10px;
            right: 15px;
            font-size: 24px;
            cursor: pointer;
        }

        .popup-image {
            width: 100%;
            max-width: 100%;
            height: auto;
            border-radius: 5px;
            cursor: pointer;
        }

        @media (max-width: 600px) {
            .popup-content {
                width: 90%;
                padding: 15px;
            }

            .popup-image {
                max-width: 100%;
                height: auto;
            }
        }
    `;
    document.head.appendChild(style);
});
*/




